import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SpinnerService {

  private readonly counter = signal(0);

  readonly showSpinner = computed(() => this.counter() > 0);

  show(): void {
    this.counter.update(v => v + 1);
  }

  hide(): void {
    this.counter.update(v => Math.max(0, v - 1));
  }
}
